var _Loader;
import { Loader } from '@crehana/ui';
import { useTranslation } from "../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Loading = function Loading() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-w-[31rem] tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-3.2 tw-text-neutral-light-100",
    children: [_Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {
      size: 48,
      isWhite: true,
      className: "tw-mb-2.4"
    })), /*#__PURE__*/_jsx("span", {
      className: "tw-font-subtitle4 tw-mb-0.8",
      children: t('AI_LABEL_TITLE')
    }), /*#__PURE__*/_jsx("span", {
      className: "tw-font-body4",
      children: t('AI_LOADING')
    })]
  });
};
export default Loading;